/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MetricsInputs */

const en_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics`)
};

const fr_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métriques`)
};

const de_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriken`)
};

const it_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriche`)
};

const ru_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метрики`)
};

const es_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas`)
};

const zh_cn2_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指标`)
};

const ja_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メトリクス`)
};

const hi_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेट्रिक्स`)
};

const pt_pt2_metrics = /** @type {(inputs: MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas`)
};

/**
* | output |
* | --- |
* | "Metrics" |
*
* @param {MetricsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metrics = /** @type {((inputs?: MetricsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MetricsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metrics(inputs)
	if (locale === "de") return de_metrics(inputs)
	if (locale === "it") return it_metrics(inputs)
	if (locale === "ru") return ru_metrics(inputs)
	if (locale === "es") return es_metrics(inputs)
	if (locale === "zh-CN") return zh_cn2_metrics(inputs)
	if (locale === "ja") return ja_metrics(inputs)
	if (locale === "hi") return hi_metrics(inputs)
	if (locale === "pt-PT") return pt_pt2_metrics(inputs)
	return en_metrics(inputs)
});